import { render, staticRenderFns } from "./BoxesGrid.vue?vue&type=template&id=9c2eca90&scoped=true&"
import script from "./BoxesGrid.vue?vue&type=script&lang=js&"
export * from "./BoxesGrid.vue?vue&type=script&lang=js&"
import style0 from "./BoxesGrid.vue?vue&type=style&index=0&id=9c2eca90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2eca90",
  null
  
)

export default component.exports